
import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { GripVertical, Save } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Country } from './types';

interface CountryListProps {
  countries: Country[];
  onDragEnd: (result: any) => void;
  onSave: () => void;
}

export const CountryList = ({ countries, onDragEnd, onSave }: CountryListProps) => {
  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={onSave} className="flex items-center gap-2">
          <Save className="h-4 w-4" />
          Save Country Order
        </Button>
      </div>
      
      <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
        <Droppable droppableId="countries">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="space-y-2 bg-background rounded-lg p-4"
            >
              {countries.map((country, index) => (
                <Draggable
                  key={country.id}
                  draggableId={country.id.toString()}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      className="flex items-center gap-4 p-4 bg-card rounded-lg border shadow-sm"
                    >
                      <div {...provided.dragHandleProps} className="cursor-grab">
                        <GripVertical className="h-5 w-5 text-muted-foreground" />
                      </div>
                      <span className="flex-1">{country.name}</span>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};
